import {
    FiniteListWithAsyncLoaderAbstract,
    ListProps,
} from "shared/components/Components";
import { useMercuryContext } from "../context";

interface CustomerApplicationsFilterProps extends ListProps {
    data?: any[];
}

class CustomerApplicationsFilter extends FiniteListWithAsyncLoaderAbstract {
    async fetch() {
        const { context } = this.props as any;
        const props = this.props as unknown as CustomerApplicationsFilterProps;

        if (props.data && props.data.length > 0) {            
            return props.data.map((item: any) => ({
                title: item.name,
                value: item._id,
            }));
        } else {
            const { data } = await context.coreClient.get(
                "core-v1/customerApplications/paginate?page=1&limit=500"
            );

            const applications = data[0]?.documents || [];

            return applications.map((item: any) => ({
                title: item.name,
                value: item._id,
            }));
        }
    }
}

export default (props: CustomerApplicationsFilterProps) => {
    const context = useMercuryContext();
    return <CustomerApplicationsFilter context={context} {...props} />;
};
